import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const UnlockSvg = () => (
  <svg width='21' height='25' viewBox='0 0 21 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_49_6456)'>
      <path
        d='M11.4434 0.468764C12.2401 0.593721 12.9988 0.812543 13.6778 1.24315C15.2025 2.20995 16.0396 3.55691 16.1039 5.31863C16.1242 5.87184 16.1039 6.42682 16.1119 6.98062C16.1156 7.17715 16.0414 7.23757 15.8429 7.23347C15.3526 7.2233 14.8624 7.2233 14.3721 7.23347C14.165 7.23816 14.111 7.16131 14.1092 6.97358C14.1037 6.36522 14.1343 5.75745 14.081 5.1485C13.9585 3.78218 12.7788 2.59714 11.3276 2.40824C9.79924 2.20878 8.42162 2.90631 7.78306 4.19988C7.57287 4.62521 7.49932 5.07986 7.49626 5.54156C7.48891 6.68084 7.50055 7.82071 7.48829 8.95999C7.48829 9.19465 7.55325 9.26388 7.80267 9.26329C11.1295 9.25586 14.4561 9.25429 17.7824 9.2586C19.331 9.2586 20.515 10.2119 20.7767 11.6668C20.7983 11.8137 20.8067 11.9621 20.8018 12.1103C20.8018 15.2782 20.8018 18.4462 20.8018 21.6141C20.8018 23.2298 19.5149 24.4623 17.8296 24.4629C13.1416 24.4656 8.45349 24.4656 3.76541 24.4629C2.09609 24.4629 0.808551 23.2256 0.806713 21.6247C0.803036 18.4481 0.803036 15.2714 0.806713 12.0945C0.806713 10.4935 2.09364 9.26329 3.76602 9.25566C4.24709 9.25566 4.72815 9.24276 5.2086 9.26036C5.45373 9.26857 5.50766 9.18292 5.50582 8.96703C5.49642 7.7726 5.49642 6.57837 5.50582 5.38434C5.52666 2.93271 7.46256 0.836596 10.0039 0.502203C10.0597 0.495163 10.1148 0.479323 10.17 0.46759L11.4434 0.468764ZM10.8073 11.1652C8.53254 11.1652 6.25775 11.1652 3.98296 11.1652C3.1673 11.1652 2.80144 11.5172 2.80022 12.2969C2.80022 13.327 2.80022 14.3572 2.80022 15.3874C2.80022 17.409 2.80022 19.4304 2.80022 21.4516C2.80022 21.8083 2.87253 22.1368 3.19365 22.3662C3.43572 22.5422 3.71945 22.561 4.00809 22.561C8.54051 22.561 13.0733 22.561 17.6066 22.561C17.7368 22.5615 17.8668 22.5511 17.9951 22.5299C18.4449 22.453 18.6949 22.2078 18.7838 21.779C18.8083 21.6406 18.8186 21.5003 18.8144 21.3601V13.6321C18.8144 13.1557 18.8206 12.68 18.8144 12.2036C18.8034 11.5395 18.4253 11.1811 17.731 11.1658C17.6574 11.1658 17.5839 11.1658 17.5104 11.1658L10.8073 11.1652Z'
        fill='url(#paint0_linear_49_6456)'
      />
      <path
        d='M10.7712 13.8497C11.5679 13.8544 12.2297 14.2868 12.5049 14.9415C12.78 15.5962 12.6409 16.3559 12.0894 16.8346C11.8559 17.037 11.7885 17.2418 11.7977 17.5228C11.8148 18.0455 11.8062 18.5682 11.8013 19.0909C11.7964 19.6547 11.376 20.063 10.8086 20.0636C10.2411 20.0642 9.81764 19.6617 9.81213 19.0973C9.80661 18.5201 9.80416 17.9422 9.81213 17.365C9.81946 17.2812 9.80506 17.197 9.7702 17.1198C9.73535 17.0426 9.68113 16.9749 9.61235 16.9226C9.07429 16.4768 8.86839 15.8995 9.0173 15.2378C9.17541 14.5373 9.64299 14.0903 10.3655 13.8973C10.4199 13.881 10.4757 13.8692 10.5322 13.8621C10.6333 13.8533 10.7314 13.8515 10.7712 13.8497Z'
        fill='url(#paint1_linear_49_6456)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_49_6456'
        x1='0.803955'
        y1='0.46759'
        x2='21.5451'
        y2='1.12698'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_49_6456'
        x1='8.97021'
        y1='13.8497'
        x2='12.7801'
        y2='13.9356'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <clipPath id='clip0_49_6456'>
        <rect width='20' height='24' fill='white' transform='translate(0.806641 0.46875)' />
      </clipPath>
    </defs>
  </svg>
);

export const UnlockColorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={UnlockSvg} {...props} />
);
